import { atom } from 'jotai';

import type { Track } from '@/types/tracks';

export type PlatformId =
  | 'youtube'
  | 'instagram'
  | 'tiktok'
  | 'facebook'
  | 'x'
  | 'twitch'
  | 'other';

/**
 * License information for generating credit text
 */
export interface LicenseInfo {
  licenseCode: string | null;
  licenseId: string | null;
  trackPageUrl: string | null;
  youtubeChannelName: string | null;
}

/**
 * A single download event's license, used when a track has been downloaded
 * more than once so each download's code + date can be viewed individually.
 */
export interface DownloadCredit {
  dateCreated: string;
  licenseCode: string | null;
  licenseId: string | null;
}

export interface CreditDialogState {
  /** Every download event for this track, newest first (empty for single downloads) */
  downloads: DownloadCredit[];
  isOpen: boolean;
  licenseInfo: LicenseInfo;
  /** Index into `downloads` of the currently viewed download */
  selectedDownloadIndex: number;
  /** Whether to show warning about previously generated credit */
  showWarning: boolean;
  track: Track | null;
}

export const initialCreditDialogState: CreditDialogState = {
  isOpen: false,
  track: null,
  licenseInfo: {
    licenseCode: null,
    trackPageUrl: null,
    youtubeChannelName: null,
    licenseId: null,
  },
  downloads: [],
  selectedDownloadIndex: 0,
  showWarning: false,
};

export const creditDialogAtom = atom<CreditDialogState>(
  initialCreditDialogState
);
